/* Kalender (AUFGABEN-STUFE2.md, Abschnitt 6.4): Monatsblatt ab Montag und Schnellwahl. Tage als YYYY-MM-DD, „heute“ nach Berliner Zeit. */

const WOCHENTAGE = ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"] as const;
export const WOCHENTAG_KOPF = WOCHENTAGE;
export const MONATE = ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"] as const;

function alsDatum(tag: string): Date {
  return new Date(`${tag}T12:00:00Z`);
}

function alsTag(d: Date): string {
  return d.toISOString().slice(0, 10);
}

export function plusTage(tag: string, n: number): string {
  const d = alsDatum(tag);
  d.setUTCDate(d.getUTCDate() + n);
  return alsTag(d);
}

/** 0 = Montag bis 6 = Sonntag */
export function wochentag(tag: string): number {
  return (alsDatum(tag).getUTCDay() + 6) % 7;
}

/** „Mo. 26.10.“ */
export function tagMitWochentag(tag: string): string {
  const [, m, d] = tag.split("-");
  return `${WOCHENTAGE[wochentag(tag)]}. ${d}.${m}.`;
}

export interface Blatttag {
  tag: string;
  imMonat: boolean;
}

/** Monatsblatt: ganze Wochen von Montag bis Sonntag, die den Monat abdecken. monat ist 1 bis 12. */
export function monatsblatt(jahr: number, monat: number): Blatttag[][] {
  const erster = `${jahr}-${String(monat).padStart(2, "0")}-01`;
  const start = plusTage(erster, -wochentag(erster));
  const wochen: Blatttag[][] = [];
  let tag = start;
  do {
    const woche: Blatttag[] = [];
    for (let i = 0; i < 7; i++) {
      woche.push({ tag, imMonat: Number(tag.slice(5, 7)) === monat });
      tag = plusTage(tag, 1);
    }
    wochen.push(woche);
  } while (Number(tag.slice(5, 7)) === monat);
  return wochen;
}

/** Monat davor oder danach als [jahr, monat] */
export function monatVerschieben(jahr: number, monat: number, schritt: number): [number, number] {
  const n = jahr * 12 + (monat - 1) + schritt;
  return [Math.floor(n / 12), (n % 12) + 1];
}

export interface Schnellwahl {
  label: string;
  tag: string;
}

/** Heute, Morgen, Freitag (der nächste, an einem Freitag der in einer Woche), Nächste Woche (Montag), Sprintende, In 4 Wochen. */
export function schnellwahl(heuteTag: string, sprintEnde?: string | null): Schnellwahl[] {
  const wt = wochentag(heuteTag);
  const bisFreitag = (4 - wt + 7) % 7 || 7;
  const bisMontag = (7 - wt) % 7 || 7;
  const liste: Schnellwahl[] = [
    { label: "Heute", tag: heuteTag },
    { label: "Morgen", tag: plusTage(heuteTag, 1) },
    { label: "Freitag", tag: plusTage(heuteTag, bisFreitag) },
    { label: "Nächste Woche", tag: plusTage(heuteTag, bisMontag) },
  ];
  if (sprintEnde) liste.push({ label: "Sprintende", tag: sprintEnde });
  liste.push({ label: "In 4 Wochen", tag: plusTage(heuteTag, 28) });
  return liste;
}
